// -------------------------------声明-------------------------------------------
// <auto-generated>
//     此文件是自动生成的文件，对这个文件的任何修改在下次自动生成的时候都会丢失。
//     模板名称：\TTFiles\TS\Entity\Entity.tt
// </auto-generated>
// ------------------------------------------------------------------------------
import { BaseAssociation } from './BaseAssociation';
import { BEComponent } from './BEComponent';
import { BEEntity } from './BEEntity';
import { BEReferenceEntity } from './BEReferenceEntity';
import { PGContext } from '../../../../../../libs/com/MetaPattern/MDA/MD/PGContext';
import { ReferCrossAssociationExtend } from '../../../../../../extension/com/MetaPattern/MDA/MD/EntityModel/ReferCrossAssociationExtend';
/**
 * 引用交叉关联关系 实体类
 * 引用交叉关联，源端是实体，目标端是引用实体
 */
export class ReferCrossAssociation extends BaseAssociation {
  /** 组件 的ID */
  private _component_ID: string;

  /** 获取：组件 的ID */
  public get component_ID() {
    return this._component_ID;
  }

  /** 设置：组件 的ID */
  public set component_ID(value: string) {
    this._component_ID = value;
  }

  /** 组件  */
  private _component: BEComponent;

  /** 获取：组件  */
  public get component() {
    return this._component;
  }

  /** 设置：组件  */
  public set component(value: BEComponent) {
    this._component = value;
    if (value !== null) {
      this.component_ID = value.id;
    } else {
      this.component_ID = '';
    }
  }

  /** 源实体（引用方） 的ID */
  private _sourceEntity_ID: string;

  /** 获取：源实体（引用方） 的ID */
  public get sourceEntity_ID() {
    return this._sourceEntity_ID;
  }

  /** 设置：源实体（引用方） 的ID */
  public set sourceEntity_ID(value: string) {
    this._sourceEntity_ID = value;
  }

  /** 源实体（引用方）  */
  private _sourceEntity: BEEntity;

  /** 获取：源实体（引用方）  */
  public get sourceEntity() {
    return this._sourceEntity;
  }

  /** 设置：源实体（引用方）  */
  public set sourceEntity(value: BEEntity) {
    this._sourceEntity = value;
    if (value !== null) {
      this.sourceEntity_ID = value.id;
    } else {
      this.sourceEntity_ID = '';
    }
  }

  /** 目标被引用实体（被引用方） 的ID */
  private _targetReferenceEntity_ID: string;

  /** 获取：目标被引用实体（被引用方） 的ID */
  public get targetReferenceEntity_ID() {
    return this._targetReferenceEntity_ID;
  }

  /** 设置：目标被引用实体（被引用方） 的ID */
  public set targetReferenceEntity_ID(value: string) {
    this._targetReferenceEntity_ID = value;
  }

  /** 目标被引用实体（被引用方）  */
  private _targetReferenceEntity: BEReferenceEntity;

  /** 获取：目标被引用实体（被引用方）  */
  public get targetReferenceEntity() {
    return this._targetReferenceEntity;
  }

  /** 设置：目标被引用实体（被引用方）  */
  public set targetReferenceEntity(value: BEReferenceEntity) {
    this._targetReferenceEntity = value;
    if (value !== null) {
      this.targetReferenceEntity_ID = value.id;
    } else {
      this.targetReferenceEntity_ID = '';
    }
  }

  constructor() {
    super();
    ReferCrossAssociationExtend.Init(this);
    this._component_ID = '';
    this._component = null;
    this._sourceEntity_ID = '';
    this._sourceEntity = null;
    this._targetReferenceEntity_ID = '';
    this._targetReferenceEntity = null;
  }

  /**
   * 将对象进行所有属性值的复制
   * @param element 要复制的对象
   * @param hasReference 是否复制引用实体
   */
  public copyFrom(element: ReferCrossAssociation, hasReference: boolean): void {
    if (element != null) {
      super.copyFrom(element, hasReference);
      this.component_ID = element.component_ID;
      if (hasReference && element.component !== null) {
        this.component = element.component;
      }
      this.sourceEntity_ID = element.sourceEntity_ID;
      if (hasReference && element.sourceEntity !== null) {
        this.sourceEntity = element.sourceEntity;
      }
      this.targetReferenceEntity_ID = element.targetReferenceEntity_ID;
      if (hasReference && element.targetReferenceEntity !== null) {
        this.targetReferenceEntity = element.targetReferenceEntity;
      }
    }
  }

  protected Deserialize(json: any): void {
    super.Deserialize(json);
    // Add self attribute
    this.component_ID = json.Component_ID;
    // if (json.Component !== null) {
    //   this.component = BEComponent.Create(json.Component);
    // }
    this.sourceEntity_ID = json.SourceEntity_ID;
    // if (json.SourceEntity !== null) {
    //   this.sourceEntity = BEEntity.Create(json.SourceEntity);
    // }
    this.targetReferenceEntity_ID = json.TargetReferenceEntity_ID;
    // if (json.TargetReferenceEntity !== null) {
    //   this.targetReferenceEntity = BEReferenceEntity.Create(json.TargetReferenceEntity);
    // }
  }

  protected Serialize(json: any): void {
    super.Serialize(json);
    json.Component_ID = this.component_ID;
    json.SourceEntity_ID = this.sourceEntity_ID;
    json.TargetReferenceEntity_ID = this.targetReferenceEntity_ID;
  }

  /** 获取属性框上下文（替代元元数据） */
  GetPGContext (): PGContext {
    const context = new PGContext(this.designId, this.displayName);
    super.buildPGContext(context);
    return context;
  }

  static Create(json: any): ReferCrossAssociation {
    const referCrossAssociation = new ReferCrossAssociation();
    referCrossAssociation.Deserialize(json);
    referCrossAssociation.json = json;
    return referCrossAssociation;
  }
}
